import { render, staticRenderFns } from "./TempStaticCategory.vue?vue&type=template&id=13fb4ac4&"
import script from "./TempStaticCategory.vue?vue&type=script&lang=js&"
export * from "./TempStaticCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports